import React, { lazy, Component, Suspense } from "react";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch, Redirect } from "react-router-dom";
import { store, browserHistory } from "./store/createStore";
import App from "./layouts/App";
import Login from "./layouts/Login";
// import ForgetPw from "./layouts/ForgetPw";
// import ResetForgetPw from "./layouts/ResetForgetPw";
import Loading from "./components/Loading";
import NotFound from "./pages/NotFound";
import { routes } from "./router";
import { PageTransition } from "@steveeeie/react-page-transition";
import "./root.scss";

class Root extends Component {
  render() {
    let auth = localStorage.getItem("JwtToken");
    const isLogin = !!auth && window.location.pathname !== "/";
    return (
      <Provider store={store}>
        <Suspense fallback={<Loading />}>
          <ConnectedRouter history={browserHistory}>
            <Switch>
              <Route exact path="/login" component={Login} />
              {/* <Route exact path="/forget" component={ForgetPw} /> */}
              {/* <Route path="/user/reset/:token/" component={ResetForgetPw} /> */}
              {isLogin ? (
                <App>
                  <Route
                    render={({ location }) => {
                      return (
                        <PageTransition
                          preset="moveToLeftFromRight"
                          transitionKey={location.pathname}
                        >
                          <Switch location={location}>
                            {(Object.entries(routes) || []).map((route) => {
                              const { path, extraProps = {} } = route[1];
                              if (!path) return undefined;
                              const key = route[0];
                              const Component = lazy(() =>
                                import(`./pages/${key}`)
                              );
                              return (
                                <Route
                                  key={key}
                                  path={path}
                                  render={(props) =>
                                    React.createElement(Component, {
                                      ...props,
                                      ...extraProps,
                                    })
                                  }
                                />
                              );
                            })}
                            <Route
                              path="/net-zero/*"
                              exact={true}
                              component={NotFound}
                            />
                          </Switch>
                        </PageTransition>
                      );
                    }}
                  />
                </App>
              ) : (
                <Redirect to="/login" />
              )}
            </Switch>
          </ConnectedRouter>
        </Suspense>
      </Provider>
    );
  }
}

export default Root;
